import * as Yup from "yup";
import { GET_EMPLOYEE_DEPARTMENTS, GET_EMPLOYEE_DESIGNATIONS, GET_NLEARN3_LIVECLASS_PACKAGES, GET_PROJECTS_LIST, GET_TEACHERS, GET_VENDOR_ACCOUNTS, GET_VENDOR_PROJECT_USERS, GET_VENDOR_USERS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Package Name",
            value: "packageName",
            // type: "configue",
        },
        {
            title: "Department Name",
            value: "employeeDepartmentName",
            type:"configue"
        },
        {
            title: "Designation Name",
            value: "employeeDesignationName",
            type:"configue"
        },
        {
            title: "Live Session ID",
            value: "liveSessionId",
            type: "configue",
        },
        {
            title: "Status",
            value: "status",
            type: "configue",
        },
        {
            title: "Meeting Title",
            value: "meetingTitle",
            type: "configue",
        },
        {
            title: "Is Active",
            value: "isActive",
            type: "configue",
        },
        {
            title: "Schedule Actions",
            value: "ScheduleActions",
            type: "configue",
        },
        {
            title:"Host Link",
            value:"scheduleCopyAction",
            type:"configue"
        }
        
    ],
    secondaryData: [
        
        {
            title: "Scheduled Start Time",
            value: "scheduledStartTime",
            type: "configue",
        },
        {
            title: "Scheduled End Time",
            value: "scheduledEndTime",
            type: "configue",
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt",
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName",
        },
       
    ],
};

export type Nl3PackageSchedule = {

    currentTime: Date;
    nlearn3LiveclassPackageIds: string;
    projectId: string;
    vendorId: string;
    vendorAccountId: string;
    start_date_time: string;
    end_date_time: string;
    meetingTitle: string;
    meetingSubTitle: string;
    thumbnailUrl: string;
    notesUrl: string;
    departmentId: string;
    designationId: string;
    teacherId: string;
    vendorUserId: string;

};

export const Nl3PackageScheduleInitialValues: Nl3PackageSchedule = {
    currentTime: new Date(), 
    nlearn3LiveclassPackageIds: "",
    projectId: "",
    vendorId: "",
    vendorAccountId: "",
    start_date_time: "",
    end_date_time: "",
    meetingTitle: "",
    meetingSubTitle: "",
    thumbnailUrl: "",
    notesUrl: "",
    departmentId: "",
    designationId: "",
    teacherId: "",
    vendorUserId: "",
};

export const Nl3PackageScheduleMandatoryFields = [
    { id: "nlearn3LiveclassPackageIds" },
    { id: "projectId" },
    { id: "vendorId" },
    { id: "vendorAccountId" },
    { id: "start_date_time" },
    { id: "end_date_time" },
    { id: "meetingTitle" },
    // { id: "meetingSubTitle" },
    { id: "departmentId" },
    { id: "designationId" },
    { id: "teacherId" },
    { id: "vendorUserId" },
];

export const Nl3PackageScheduleValidationSchema = Yup.object().shape({
});


export const Nl3PackageScheduleProperties = [
    {
        id: "vendorId",
        type: "single-select-search",
        label: "Vendor *",
        keyValue: { label: "name", value: "id" },
        query: GET_VENDORS,
        gqlKey: "getVendors",
        dataKey: "vendors",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorAccountId",
        type: "single-select-search",
        label: "Vendor Account *",
        query: GET_VENDOR_ACCOUNTS,
        gqlKey: "getVendorAccounts",
        dataKey: "vendorAccounts",
        keyValue: { label: "associatedDomainName", value: "id" },
        searchFieldKey: "associatedDomainName",
        dependentOn: "vendorId", // 🔥 ONLY THIS IS REQUIRED
        strictDependency: true,
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "start_date_time",
        type: "date-time-picker2",
        label: "Scheduled Start Time ",
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        maxDateTime: "end_date_time",
        restrictError: true,
        required: true
    },
    {
        id: "end_date_time",
        type: "date-time-picker2",
        label: "Scheduled End Time ",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        minDateTime: "start_date_time",
        restrictError: true,
        required: true
    },
    // {
    //     id: "nlearn3LiveclassPackageId",
    //     type: "single-select-search",
    //     label: "Nl3 Liveclass Package *",
    //     keyValue: { label: "name", value: "id" },
    //     query: GET_NLEARN3_LIVECLASS_PACKAGES,
    //     gqlKey: "getNlearn3LiveclassPackages",
    //     dataKey: "nlearn3LiveclassPackages",
    //     searchFieldKey: "searchName",
    //     className: "name-styles",
    //     breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    //     required: true,
    // },
    {
        id: "nlearn3LiveclassPackageIds",
        type: "multi-select-dependency",
        label: "Nl3 Liveclass Package *",
        list: "nl3_liveclass_packages_gq",
        keyValue: { label: "nameWithCount", value: "id" },
        fieldKeyLists: {},
        options: [],
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: true,
    },
    {
        id: "projectId",
        type: "single-select-search",
        label: "Project *",
        keyValue: { label: "name", value: "id" },
        query: GET_PROJECTS_LIST,
        gqlKey: "getProjects",
        dataKey: "projects",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },

    {
        id: "meetingTitle",
        type: "text",
        label: "Meeting Title",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    // {
    //     id: "meetingSubTitle",
    //     type: "text",
    //     label: "Meeting Sub Title *",
    //     breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    //     required: false,
    // },

    // {
    //     id: "thumbnailUrl",
    //     type: "text",
    //     label: "Thumbnail URL",
    //     breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    //     required: false,
    // },
    // {
    //     id: "notesUrl",
    //     type: "text",
    //     label: "Notes URL",
    //     breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    //     required: false,
    // },
    {
        id: "departmentId",
        type: "single-select-search",
        label: "Department *",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DEPARTMENTS,
        gqlKey: "getEmployeeDepartments",
        dataKey: "employeeDepartments",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "designationId",
        type: "single-select-search",
        label: "Designation *",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DESIGNATIONS,
        gqlKey: "getEmployeeDesignations",
        dataKey: "employeeDesignations",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "teacherId",
        type: "single-select-search",
        label: "Host *",
        keyValue: {
            label: "employeeDropdownLabel",
            value: "employeeDropdownValue"
        },
        query: GET_TEACHERS,
        gqlKey: "getTeachers",
        dataKey: "teachers",
        dependentOn: ["departmentId", "designationId"],
        searchFieldKey: "searchName",
        strictDependency: false,
        extraPayload: { isArchived: false },
        formatDependentPayload: ([departmentId, designationId]: any) => {
            return {
                ...(departmentId && { departmentId: Number(departmentId) }),
                ...(designationId && { designationId: Number(designationId) }),
            };
        },
        formatData: (teachers: any[]) => {
            if (!teachers) return [];
            return teachers.map((teacher: any) => ({
                ...teacher,
                employeeDropdownLabel: `${teacher?.employee?.employeeId || ""} ${teacher?.employee?.firstName || ""} ${teacher?.employee?.lastName || ""}`.trim(),
                employeeDropdownValue: teacher?.id
            }));
        },
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorUserId",
        type: "single-select-search",
        label: "Licensed Vendor User *",
        keyValue: { label: "vendorEmail", value: "vendorUserId" },
        query: GET_VENDOR_PROJECT_USERS,
        gqlKey: "getVendorProjectUsers",
        dataKey: "vendorProjectUsers",
        searchFieldKey: "vendorEmail",
        extraPayload: { userType: "Licensed",  },
        dependentOn: "projectId",
        formatDependentPayload: (projectId: any) => {
            return {
                userType: "Licensed",
                ...(projectId && { projectId })
            };
        },
        strictDependency: false,
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}
